import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  flex: 1 0 0;
  height: 100%;
  align-self: stretch;
  position: relative;
  border-radius: 8px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: var(--white, #fff);
  overflow: hidden;
  min-height: calc(100vh - 9.75rem - calc(2.2rem - 0.4rem) - 78px - 24px);
  @media ${queries.less.mdxs} {
    flex: 1 1 auto;
    min-height: auto;
  }

  .steam {
    transition: height 0.3s ease-in-out;
    width: calc(100% - 16px);
    height: 56px;
    position: absolute;
    left: 0px;

    &[data-hide='true'] {
      height: 0px;
    }

    @media ${queries.less.mdxs} {
      height: 0px;
    }
  }

  .bottom-steam {
    bottom: 0px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 23.21%,
      #fff 100%
    );
  }

  .top-steam {
    top: 73px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0) 23.21%, #fff 100%);
  }
`

const Header = styled.div`
  display: flex;
  padding: 24px;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex: 0 0 auto;
  border-bottom: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
`

const Body = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  flex: 1 1 auto;
  overflow: auto;
`

const Title = styled.div`
  color: #2f2b3d;
  opacity: 0.9;
  /* Heading 2 - Mobile */
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.4px;
  flex: 1 0 0;
`

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 0 1;
  height: 100%;
  width: 100%;
  align-self: stretch;
  position: relative;
  background: #fff;
`

const Styles = {
  Container,
  Header,
  Body,
  Title,
  ActionsWrapper,
}

export default Styles
